<div class="white-block shadow-block mb-4 ib-preview-extra">
  <h3><strong>Seat Map</strong></h3>
  @if (src) {
    <img nz-image [nzSrc]="src" [src]="src" alt="Seat map" />
  } @else {
    <p class="ib-preview-empty">No seat map image</p>
  }
</div>
